export var textStyleTokens = {
  body: {
    default: {
      font: {
        family: function family(_ref) {
          var token = _ref.token;
          return token('typography.family.normal');
        },
        size: function size(_ref2) {
          var token = _ref2.token;
          return token('typography.size.m');
        },
        weight: function weight(_ref3) {
          var token = _ref3.token;
          return token('typography.weight.medium');
        }
      },
      lineHeight: function lineHeight(_ref4) {
        var token = _ref4.token;
        return token('typography.lineHeight.m');
      },
      letterSpacing: function letterSpacing(_ref5) {
        var token = _ref5.token;
        return token('typography.letterSpacing.normal');
      },
      color: function color(_ref6) {
        var token = _ref6.token;
        return token('color.textStyle.body.default');
      }
    },
    contrast: {
      color: function color(_ref7) {
        var token = _ref7.token;
        return token('color.textStyle.body.constrast');
      }
    }
  },
  paragraph: {
    default: {
      font: {
        size: function size(_ref8) {
          var token = _ref8.token;
          return token('typography.size.l');
        },
        weight: function weight(_ref9) {
          var token = _ref9.token;
          return token('typography.weight.medium');
        },
        height: function height(_ref10) {
          var token = _ref10.token;
          return token('typography.lineHeight.l');
        }
      },
      lineHeight: function lineHeight(_ref11) {
        var token = _ref11.token;
        return token('typography.lineHeight.l');
      },
      letterSpacing: function letterSpacing(_ref12) {
        var token = _ref12.token;
        return token('typography.letterSpacing.normal');
      },
      color: function color(_ref13) {
        var token = _ref13.token;
        return token('color.textStyle.body.default');
      },
      padding: {
        top: function top(_ref14) {
          var token = _ref14.token;
          return token('spacing.s');
        },
        bottom: function bottom(_ref15) {
          var token = _ref15.token;
          return token('spacing.s');
        }
      }
    }
  },
  link: {
    default: {
      idle: {
        textDecoration: 'underline',
        color: function color(_ref16) {
          var token = _ref16.token;
          return token('color.textStyle.link.idle.default');
        }
      },
      hover: {
        color: function color(_ref17) {
          var token = _ref17.token;
          return token('color.textStyle.link.hover.default');
        }
      },
      active: {
        color: function color(_ref18) {
          var token = _ref18.token;
          return token('color.textStyle.link.idle.default');
        }
      },
      focused: {
        color: function color(_ref19) {
          var token = _ref19.token;
          return token('color.textStyle.link.idle.default');
        }
      },
      disabled: {
        color: function color(_ref20) {
          var token = _ref20.token;
          return token('color.state.disabled.dark');
        }
      }
    }
  },
  heading: {
    display: {
      font: {
        size: function size(_ref21) {
          var token = _ref21.token;
          return token('typography.size.9xl');
        },
        weight: function weight(_ref22) {
          var token = _ref22.token;
          return token('typography.weight.bold');
        },
        family: function family(_ref23) {
          var token = _ref23.token;
          return token('typography.family.normal-brand');
        }
      },
      lineHeight: function lineHeight(_ref24) {
        var token = _ref24.token;
        return token('typography.lineHeight.7xl');
      }
    },
    1: {
      font: {
        size: function size(_ref25) {
          var token = _ref25.token;
          return token('typography.size.6xl');
        },
        weight: function weight(_ref26) {
          var token = _ref26.token;
          return token('typography.weight.bold');
        },
        family: function family(_ref27) {
          var token = _ref27.token;
          return token('typography.family.normal-brand');
        }
      },
      lineHeight: function lineHeight(_ref28) {
        var token = _ref28.token;
        return token('typography.lineHeight.4xl');
      }
    },
    2: {
      font: {
        size: function size(_ref29) {
          var token = _ref29.token;
          return token('typography.size.5xl');
        },
        weight: function weight(_ref30) {
          var token = _ref30.token;
          return token('typography.weight.bold');
        },
        family: function family(_ref31) {
          var token = _ref31.token;
          return token('typography.family.normal-brand');
        }
      },
      lineHeight: function lineHeight(_ref32) {
        var token = _ref32.token;
        return token('typography.lineHeight.3xl');
      }
    },
    3: {
      font: {
        size: function size(_ref33) {
          var token = _ref33.token;
          return token('typography.size.3xl');
        },
        weight: function weight(_ref34) {
          var token = _ref34.token;
          return token('typography.weight.bold');
        },
        family: function family(_ref35) {
          var token = _ref35.token;
          return token('typography.family.normal-brand');
        }
      },
      lineHeight: function lineHeight(_ref36) {
        var token = _ref36.token;
        return token('typography.lineHeight.xl');
      }
    },
    4: {
      font: {
        size: function size(_ref37) {
          var token = _ref37.token;
          return token('typography.size.xl');
        },
        weight: function weight(_ref38) {
          var token = _ref38.token;
          return token('typography.weight.bold');
        },
        family: function family(_ref39) {
          var token = _ref39.token;
          return token('typography.family.normal-brand');
        }
      },
      lineHeight: function lineHeight(_ref40) {
        var token = _ref40.token;
        return token('typography.lineHeight.m');
      }
    },
    5: {
      font: {
        size: function size(_ref41) {
          var token = _ref41.token;
          return token('typography.size.xl');
        },
        weight: function weight(_ref42) {
          var token = _ref42.token;
          return token('typography.weight.bold');
        }
      },
      lineHeight: function lineHeight(_ref43) {
        var token = _ref43.token;
        return token('typography.lineHeight.xl');
      }
    },
    6: {
      font: {
        size: function size(_ref44) {
          var token = _ref44.token;
          return token('typography.size.l');
        },
        weight: function weight(_ref45) {
          var token = _ref45.token;
          return token('typography.weight.bold');
        }
      },
      lineHeight: function lineHeight(_ref46) {
        var token = _ref46.token;
        return token('typography.lineHeight.l');
      }
    }
  },
  normal: {
    default: {
      font: {
        size: function size(_ref47) {
          var token = _ref47.token;
          return token('typography.size.m');
        },
        weight: function weight(_ref48) {
          var token = _ref48.token;
          return token('typography.weight.medium');
        }
      },
      lineHeight: function lineHeight(_ref49) {
        var token = _ref49.token;
        return token('typography.lineHeight.m');
      }
    },
    semibold: {
      font: {
        size: function size(_ref50) {
          var token = _ref50.token;
          return token('typography.size.m');
        },
        weight: function weight(_ref51) {
          var token = _ref51.token;
          return token('typography.weight.semibold');
        }
      },
      lineHeight: function lineHeight(_ref52) {
        var token = _ref52.token;
        return token('typography.lineHeight.m');
      }
    },
    bold: {
      font: {
        size: function size(_ref53) {
          var token = _ref53.token;
          return token('typography.size.m');
        },
        weight: function weight(_ref54) {
          var token = _ref54.token;
          return token('typography.weight.bold');
        }
      },
      lineHeight: function lineHeight(_ref55) {
        var token = _ref55.token;
        return token('typography.lineHeight.m');
      }
    }
  },
  large: {
    default: {
      font: {
        size: function size(_ref56) {
          var token = _ref56.token;
          return token('typography.size.l');
        },
        weight: function weight(_ref57) {
          var token = _ref57.token;
          return token('typography.weight.medium');
        }
      },
      lineHeight: function lineHeight(_ref58) {
        var token = _ref58.token;
        return token('typography.lineHeight.l');
      }
    },
    semibold: {
      font: {
        size: function size(_ref59) {
          var token = _ref59.token;
          return token('typography.size.l');
        },
        weight: function weight(_ref60) {
          var token = _ref60.token;
          return token('typography.weight.semibold');
        }
      },
      lineHeight: function lineHeight(_ref61) {
        var token = _ref61.token;
        return token('typography.lineHeight.l');
      }
    },
    bold: {
      font: {
        size: function size(_ref62) {
          var token = _ref62.token;
          return token('typography.size.l');
        },
        weight: function weight(_ref63) {
          var token = _ref63.token;
          return token('typography.weight.bold');
        }
      },
      lineHeight: function lineHeight(_ref64) {
        var token = _ref64.token;
        return token('typography.lineHeight.l');
      }
    }
  },
  small: {
    default: {
      font: {
        size: function size(_ref65) {
          var token = _ref65.token;
          return token('typography.size.s');
        },
        weight: function weight(_ref66) {
          var token = _ref66.token;
          return token('typography.weight.medium');
        }
      },
      lineHeight: function lineHeight(_ref67) {
        var token = _ref67.token;
        return token('typography.lineHeight.s');
      }
    },
    semibold: {
      font: {
        size: function size(_ref68) {
          var token = _ref68.token;
          return token('typography.size.s');
        },
        weight: function weight(_ref69) {
          var token = _ref69.token;
          return token('typography.weight.semibold');
        }
      },
      lineHeight: function lineHeight(_ref70) {
        var token = _ref70.token;
        return token('typography.lineHeight.s');
      }
    },
    bold: {
      font: {
        size: function size(_ref71) {
          var token = _ref71.token;
          return token('typography.size.s');
        },
        weight: function weight(_ref72) {
          var token = _ref72.token;
          return token('typography.weight.bold');
        }
      },
      lineHeight: function lineHeight(_ref73) {
        var token = _ref73.token;
        return token('typography.lineHeight.s');
      }
    }
  },
  tiny: {
    default: {
      font: {
        size: function size(_ref74) {
          var token = _ref74.token;
          return token('typography.size.xs');
        },
        weight: function weight(_ref75) {
          var token = _ref75.token;
          return token('typography.weight.medium');
        }
      },
      lineHeight: function lineHeight(_ref76) {
        var token = _ref76.token;
        return token('typography.lineHeight.xs');
      }
    },
    semibold: {
      font: {
        size: function size(_ref77) {
          var token = _ref77.token;
          return token('typography.size.xs');
        },
        weight: function weight(_ref78) {
          var token = _ref78.token;
          return token('typography.weight.semibold');
        }
      },
      lineHeight: function lineHeight(_ref79) {
        var token = _ref79.token;
        return token('typography.lineHeight.xs');
      }
    },
    bold: {
      font: {
        size: function size(_ref80) {
          var token = _ref80.token;
          return token('typography.size.xs');
        },
        weight: function weight(_ref81) {
          var token = _ref81.token;
          return token('typography.weight.bold');
        }
      },
      lineHeight: function lineHeight(_ref82) {
        var token = _ref82.token;
        return token('typography.lineHeight.xs');
      }
    }
  },
  label: {
    font: {
      size: function size(_ref83) {
        var token = _ref83.token;
        return token('textStyle.small.semibold.font.size');
      },
      weight: function weight(_ref84) {
        var token = _ref84.token;
        return token('textStyle.small.semibold.font.weight');
      }
    },
    lineHeight: function lineHeight(_ref85) {
      var token = _ref85.token;
      return token('textStyle.small.semibold.lineHeight');
    }
  }
};